// [QR-TABLES] Planche de QR codes à imprimer (un par table)
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import QRCode from "react-qr-code";
import { Printer, ChevronLeft, Loader2 } from "lucide-react";
import { useAuth, API } from "../App";
import { Button } from "../components/ui/button";

export default function TablesQR() {
  const { getAuthHeaders } = useAuth();
  const [tables, setTables] = useState(null);
  const boutique = JSON.parse(localStorage.getItem("boutique") || "{}");

  useEffect(() => {
    axios.get(`${API}/tables`, getAuthHeaders()).then((r) => setTables(r.data.tables.filter((t) => t.token))).catch(() => setTables([]));
  }, [getAuthHeaders]);

  if (!tables) return <div className="flex justify-center py-24"><Loader2 className="w-8 h-8 animate-spin" /></div>;

  return (
    <div className="p-4 sm:p-6" data-testid="qr-sheet-page">
      <div className="flex items-center gap-3 mb-6 print:hidden">
        <Button variant="ghost" asChild><Link to="/admin/tables"><ChevronLeft className="w-4 h-4 mr-1" /> Tables</Link></Button>
        <h1 className="text-xl font-bold flex-1">QR codes des tables</h1>
        <Button onClick={() => window.print()} data-testid="print-qr-btn"><Printer className="w-4 h-4 mr-2" /> Imprimer</Button>
      </div>
      <p className="text-sm text-muted-foreground mb-6 print:hidden">Imprimez, découpez, plastifiez. Un QR par table : le client scanne et commande depuis son téléphone.</p>
      {tables.length === 0 && <p className="text-muted-foreground">Aucune table. Créez-en depuis l'écran Tables.</p>}
      <div className="grid gap-4 print:gap-2" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))" }}>
        {tables.map((t) => (
          <div key={t.id} className="rounded-2xl border-2 border-black bg-white text-black p-5 flex flex-col items-center text-center break-inside-avoid print:rounded-none" data-testid={`qr-card-${t.id}`}>
            {boutique.logo && <img src={boutique.logo} alt="" className="w-10 h-10 rounded-lg object-cover mb-2" />}
            <p className="font-black text-base leading-tight">{boutique.nom || boutique.name || boutique.boutique_name || "Notre établissement"}</p>
            <p className="text-2xl font-black mt-1">{t.name}</p>
            <div className="my-3 p-2 bg-white"><QRCode value={`${window.location.origin}/t/${t.token}`} size={150} /></div>
            <p className="text-xs font-semibold">📱 Scannez pour commander</p>
            <p className="text-[10px] text-gray-500 mt-1">Vins · Bières · Boissons · Plats</p>
          </div>
        ))}
      </div>
      <style>{`@media print { body { background: #fff !important; } .sidebar-premium, header, nav, aside { display: none !important; } main { padding: 0 !important; } }`}</style>
    </div>
  );
}
